import {
  PLUGIN_LOAD_ROLES_BEGIN,
  PLUGIN_LOAD_ROLES_SUCCESS,
  PLUGIN_LOAD_ROLES_FAILURE,
  PLUGIN_LOAD_ROLES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadRoles(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_LOAD_ROLES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/role/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_LOAD_ROLES_SUCCESS,
            data: res.data.content,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PLUGIN_LOAD_ROLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadRolesError() {
  return {
    type: PLUGIN_LOAD_ROLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_LOAD_ROLES_BEGIN:
      return {
        ...state,
        loadRolesPending: true,
        loadRolesError: null,
      };

    case PLUGIN_LOAD_ROLES_SUCCESS:
      return {
        ...state,
        loadRolesPending: false,
        loadRolesError: null,
        roles: action.data,
      };

    case PLUGIN_LOAD_ROLES_FAILURE:
      return {
        ...state,
        loadRolesPending: false,
        loadRolesError: action.data.error,
      };

    case PLUGIN_LOAD_ROLES_DISMISS_ERROR:
      return {
        ...state,
        loadRolesError: null,
      };

    default:
      return state;
  }
}
